<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5" v-if="(isRegistered===true)">Edit Admission Form</p>
            <p class="title is-5" v-if="(isRegistered===false)">Create Admission Form</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link slot="right" :to="{ name: 'admission' }" class="button is-small is-link">Back </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
       <form class="container" name="admission" @submit.prevent="saveAdmission">
<div class="container">
<AdmissionElement formType='createAdmission' :isWritable='this.message'  v-model="parentdata"/>
</div>
        <div class="container">
          <RegStudentElement :formType='this.typeForm' :isWritable='this.message'  v-model="parentdata"/>
        </div>
        <div class="container">
          <RegParentElement :formType='this.typeForm' :isWritable='this.message' parentType="father"  v-model="studentData" />
        </div>
        <div class="container">
          <RegParentElement :formType='this.typeForm' :isWritable='this.message' parentType="mother" v-model="studentData" />
        </div>
        <div class="container">
          <AddressElement :formType='this.typeForm' :isWritable ='this.message' v-model="studentData" />
        </div>
<div class="container">
          <OtherElement formType="createAdmission" :isWritable="this.message" v-model="parentdata" />
        </div>
         <div class="container">
         <SiblingElement :formType='this.typeForm' :isWritable ='this.message' v-model='registrationData' />
        </div>
        <div class="container">
         <HealthElement :formType='this.typeForm' :isWritable ='this.message' v-model='registrationData' />
        </div>
        <div class="container" v-if="this.isLoaded==='true'">
         <RegDocumentElement :formType='this.typeForm' :isWritable ='this.message' v-model='registrationData' :enquiryID="parentdata.id" :enquiryCode="parentdata.enquiryCodeDown" :franchiseeID="parentdata.franchisee.id"/>
        </div>

        <footer class="column has-text-right">
          <button class="button is-success" type="submit" :disabled='hasClicked'>
            Save
          </button>
        </footer>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import RegStudentElement from '@/components/Forms/Elements/RegStudentElement'
import RegParentElement from '@/components/Forms/Elements/RegParentElement'
import OtherElement from '@/components/Forms/Elements/OtherElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import HealthElement from '@/components/Forms/Elements/HealthElement'
import RegDocumentElement from '@/components/Forms/Elements/RegDocs'
import SiblingElement from '@/components/Forms/Elements/SiblingElement'
import AdmissionElement from '@/components/Forms/Elements/AdmissionElement'

import _ from 'lodash'
import moment from 'moment'
import stores from '@/stores'

export default {
  name: 'admissionForm',
  props: ['enquiryID',
    'registrationID',
    'enquiryCode',
    'registrationCode',
    'formType'],
  components: {
    RegStudentElement,
    RegParentElement,
    AddressElement,

    HealthElement,
    RegDocumentElement,
    SiblingElement,
    AdmissionElement,
    OtherElement
  },
  data: function () {
    return {
      checkboxGroup: ['SMS', 'Email'],
      enquiry: {},
      academicYears: [],
      parentdata: {},
      studentData: {},
      registrationData: {},
      data: [],
      hasClicked: false,
      loader: true,
      formData: {},
      message: '',
      typeForm: '',
      isLoaded: 'false',
      isRegistered: false
    }
  },
  async created () {
    await this.onstart()
    await this.writable()
  },
  async mounted () {
  },
  methods: {
    saveAdmission: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.hasClicked = true
        this.loader = true
        this.parentdata.enquiry = ''

        if (this.parentdata.pointOfContact === 'MOTHER') {
          if (_.isEmpty(this.studentData.motherName) || _.isEmpty(this.studentData.motherEmailID) || _.isEmpty(this.studentData.motherMobile)) {
            this.loadingComponent.close()
            this.lock = false
            this.hasClicked = false
            return this.$buefy.dialog.alert({
              message: 'Please fill Mother Details as you have selected Mother as Point of contact',
              type: 'is-danger',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
        let inputData = {
          enquiryID: this.enquiryID,
          classID: this.parentdata.classID,
          sectionID: this.parentdata.sectionID,
          enquiryCode: this.parentdata.enquiryCode,
          motherTongue: this.parentdata.motherTongue,
          exposureToEnglishLanguage: this.parentdata.exposureToEnglishLanguage,
          identificationMarks: this.parentdata.identificationMarks,
          franchiseeID: this.parentdata.franchisee.id,
          academicYearID: this.studentData.academicYearID,
          studentFirstName: this.parentdata.studentFirstName,
          studentMiddleName: this.parentdata.studentMiddleName,
          studentLastName: this.parentdata.studentLastName,
          fatherName: this.studentData.fatherName,
          fatherMobile: this.studentData.fatherMobile,
          fatherEmail: this.studentData.fatherEmailID,
          fatherOccupation: this.studentData.fatherOccupation,
          motherName: this.studentData.motherName,
          motherEmailID: this.studentData.motherEmailID,
          motherMobile: this.studentData.motherMobile,
          motherOccupation: this.studentData.motherOccupation,
          address1: this.studentData.address1,
          address: this.studentData.address,
          pincode: this.parentdata.pincode,
          countryName: this.studentData.countryName,
          state: this.studentData.state,
          city: this.studentData.city,
          locality: this.studentData.locality,
          dateOfBirth: this.parentdata.dateOfBirth,
          placeOfBirth: this.parentdata.placeOfBirth,
          gender: this.parentdata.gender,
          pointOfContact: this.parentdata.pointOfContact,
          guardianName: this.studentData.guardianName,
          guardianMobile: this.studentData.guardianMobile,
          guardianEmailID: this.studentData.guardianEmailID,
          fatherDesignation: this.studentData.fatherDesignation,
          fatherQualification: this.studentData.fatherQualification,
          fatherOrganisation: this.studentData.fatherOrganisation,
          fatherOfficePhoneNo: this.studentData.fatherOfficePhoneNo,
          fatherOfficeAddress: this.studentData.fatherOfficeAddress,
          motherQualification: this.studentData.motherQualification,
          motherOrganisation: this.studentData.motherOrganisation,
          motherOfficePhoneNo: this.studentData.motherOfficePhoneNo,
          motherOfficeAddress: this.studentData.motherOfficeAddress,
          motherDesignation: this.studentData.motherDesignation,
          emergencyContactDetails: this.registrationData.emergencyContactDetails,
          siblingName: this.registrationData.siblingName,
          siblingAge: this.registrationData.siblingAge,
          siblingClass: this.registrationData.siblingClass,
          siblingSchool: this.registrationData.siblingSchool,
          siblingOtherSchool: this.registrationData.siblingOtherSchool,
          referralsChildName: this.registrationData.referralsChildName,
          referralsChildAge: this.registrationData.referralsChildAge,
          referralsFatherMotherName: this.registrationData.referralsFatherMotherName,
          referralsFatherMotherMobileNo: this.registrationData.referralsFatherMotherMobileNo,
          referralsRelation: this.registrationData.referralsRelation,
          bloodGroup: this.registrationData.bloodGroup,
          anySeriousAccidentsOrIllnessOrOperarions: this.registrationData.anySeriousAccidentsOrIllnessOrOperarions,
          dateForSeriousAccidentsOrIllnessOrOperarions: this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions,
          allergiesOrAsthmaOrBreathlessness: this.registrationData.allergiesOrAsthmaOrBreathlessness,
          anyOtherAliment: this.registrationData.anyOtherAliment,
          specialCare: this.registrationData.specialCare,
          foodAllergies: this.registrationData.foodAllergies,
          drugAllergies: this.registrationData.drugAllergies,
          anyPhysicalChallengeOrLearningDifficulties: this.registrationData.anyPhysicalChallengeOrLearningDifficulties,
          prescribedMedication: this.registrationData.prescribedMedication,
          techniqueToDisciplineYourChild: this.registrationData.techniqueToDisciplineYourChild,
          childsUsualReactionToBeingDisciplined: this.registrationData.childsUsualReactionToBeingDisciplined,
          childsReactionForNewSituation: this.registrationData.childsReactionForNewSituation,
          isNewPeopleEasilyAcceptable: this.registrationData.isNewPeopleEasilyAcceptable,
          familyDoctorOrPhysicianName: this.registrationData.familyDoctorOrPhysicianName,
          familyDoctorOrPhysicianQualification: this.registrationData.familyDoctorOrPhysicianQualification,
          practicingClinicDetails: this.registrationData.practicingClinicDetails,
          practicingClinicOfficeTelephone: this.registrationData.practicingClinicOfficeTelephone,
          practicingClinicMobileNo: this.registrationData.practicingClinicMobileNo,
          practicingClinicEmailID: this.registrationData.practicingClinicEmailID,
          chikenpoxVaricellaVaccineDate: this.registrationData.chikenpoxVaricellaVaccineDate,
          diptheriaDTapVaccineDate: this.registrationData.diptheriaDTapVaccineDate,
          haemophilusInfluenzaTypeBHiBVaccineDate: this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate,
          hepatitisAHepAVaccineDate: this.registrationData.hepatitisAHepAVaccineDate,
          hepatitisBHepBVaccineDate: this.registrationData.hepatitisBHepBVaccineDate,
          tetanusDTapDate: this.registrationData.tetanusDTapDate,
          studentPhoto: this.registrationData.studentPhoto,
          fatherPhoto: this.registrationData.fatherPhoto,
          motherPhoto: this.registrationData.motherPhoto,
          birthCertificate: this.registrationData.birthCertificate,
          transferCertificate: this.registrationData.transferCertificate,
          immunisationCertificate: this.registrationData.immunisationCertificate,
          studentAadharCard: this.registrationData.studentAadharCard,
          fatherAadharCard: this.registrationData.fatherAadharCard,
          motherAadharCard: this.registrationData.motherAadharCard,
          healthCertificate: this.registrationData.healthCertificate,
          studentPhotoUrl: this.registrationData.studentPhotoUrl,
          fatherPhotoUrl: this.registrationData.fatherPhotoUrl,
          motherPhotoUrl: this.registrationData.motherPhotoUrl,
          birthCertificateUrl: this.registrationData.birthCertificateUrl,
          transferCertificateUrl: this.registrationData.transferCertificateUrl,
          immunisationCertificateUrl: this.registrationData.immunisationCertificateUrl,
          studentAadharCardUrl: this.registrationData.studentAadharCardUrl,
          fatherAadharCardUrl: this.registrationData.fatherAadharCardUrl,
          motherAadharCardUrl: this.registrationData.motherAadharCardUrl,
          healthCertificateUrl: this.registrationData.healthCertificateUrl,
          registrationCode: !_.isEmpty(this.registrationData.registrationCode) ? this.registrationData.registrationCode : '',
          updatedBy: stores.user.userInfo.email,
          createdBy: stores.user.userInfo.email
        }
        const formData = new FormData()
        for (var key in inputData) {
          if (typeof inputData[key] === 'undefined' || inputData[key] === null) {
            inputData[key] = ''
          }
          formData.append(key, inputData[key])
        }

        await http.post(`${constants.API_URL}/api/create-admission`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.loader = false
        this.$router.push({ name: 'admission' })

        return this.$buefy.dialog.alert({
          message: 'Admission completed successfully',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While updating admission Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },

    onstart: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/registration-details/${this.enquiryCode}`)
        this.parentdata = response.data
        if (!_.isEmpty(this.parentdata.enquiryRegistrations)) {
          let registrationData = this.parentdata.enquiryRegistrations
          this.registrationData = registrationData[0]
          this.isRegistered = true
        }
        this.studentData = this.parentdata
        this.studentData.address = this.parentdata.address1
        this.parentdata.gender = _.startCase(_.toLower(this.parentdata.gender))
        this.parentdata.exposureToEnglishLanguage = !_.isEmpty(this.registrationData.exposureToEnglishLanguage) ? this.registrationData.exposureToEnglishLanguage : ''
        this.parentdata.motherTongue = !_.isEmpty(this.registrationData.motherTongue) ? this.registrationData.motherTongue : ''
        this.parentdata.identificationMarks = !_.isEmpty(this.registrationData.identificationMarks) ? this.registrationData.identificationMarks : ''
        this.parentdata.emergencyContactDetails = !_.isEmpty(this.registrationData.emergencyContactDetails) ? this.registrationData.emergencyContactDetails : ''
        this.parentdata.fatherDesignation = !_.isEmpty(this.registrationData.fatherDesignation) ? this.registrationData.fatherDesignation : ''
        this.parentdata.fatherQualification = !_.isEmpty(this.registrationData.fatherQualification) ? this.registrationData.fatherQualification : ''
        this.parentdata.fatherOrganisation = !_.isEmpty(this.registrationData.fatherOrganisation) ? this.registrationData.fatherOrganisation : ''
        this.parentdata.fatherOfficePhoneNo = !_.isEmpty(this.registrationData.fatherOfficePhoneNo) ? this.registrationData.fatherOfficePhoneNo : ''
        this.parentdata.fatherOfficeAddress = !_.isEmpty(this.registrationData.fatherOfficeAddress) ? this.registrationData.fatherOfficeAddress : ''
        this.parentdata.motherDesignation = !_.isEmpty(this.registrationData.motherDesignation) ? this.registrationData.motherDesignation : ''
        this.parentdata.motherQualification = !_.isEmpty(this.registrationData.motherQualification) ? this.registrationData.motherQualification : ''
        this.parentdata.motherOrganisation = !_.isEmpty(this.registrationData.motherOrganisation) ? this.registrationData.motherOrganisation : ''
        this.parentdata.motherOfficePhoneNo = !_.isEmpty(this.registrationData.motherOfficePhoneNo) ? this.registrationData.motherOfficePhoneNo : ''
        this.parentdata.motherOfficeAddress = !_.isEmpty(this.registrationData.motherOfficeAddress) ? this.registrationData.motherOfficeAddress : ''
        this.registrationData.franchiseeID = this.parentdata.franchisee.id
        this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions = !_.isEmpty(this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions) ? moment(this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions).format('YYYY-MM-DD') : ''
        this.registrationData.chikenpoxVaricellaVaccineDate = !_.isEmpty(this.registrationData.chikenpoxVaricellaVaccineDate) ? moment(this.registrationData.chikenpoxVaricellaVaccineDate).format('YYYY-MM-DD') : ''
        this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate = !_.isEmpty(this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate) ? moment(this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate).format('YYYY-MM-DD') : ''
        this.registrationData.hepatitisAHepAVaccineDate = !_.isEmpty(this.registrationData.hepatitisAHepAVaccineDate) ? moment(this.registrationData.hepatitisAHepAVaccineDate).format('YYYY-MM-DD') : ''
        this.registrationData.hepatitisBHepBVaccineDate = !_.isEmpty(this.registrationData.hepatitisBHepBVaccineDate) ? moment(this.registrationData.hepatitisBHepBVaccineDate).format('YYYY-MM-DD') : ''
        this.registrationData.tetanusDTapDate = !_.isEmpty(this.registrationData.tetanusDTapDate) ? moment(this.registrationData.tetanusDTapDate).format('YYYY-MM-DD') : ''
        this.registrationData.diptheriaDTapVaccineDate = !_.isEmpty(this.registrationData.diptheriaDTapVaccineDate) ? moment(this.registrationData.diptheriaDTapVaccineDate).format('YYYY-MM-DD') : ''
        this.parentdata.dateOfBirth = moment(this.registrationData.dateOfBirth).format('YYYY-MM-DD')
        this.parentdata.placeOfBirth = this.registrationData.placeOfBirth
        this.registrationData.enquiryID = this.enquiryID
        this.registrationData.enquiryCode = this.parentdata.enquiryCode
        this.isLoaded = 'true'
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    writable: async function () {
      if (this.registrationID) {
        this.message = 'true'
        this.typeForm = 'edit_admission'
      } else {
        this.message = 'true'
        this.typeForm = 'admission'
      }
    },
    getS3uploadedURL: async function (fileName) {
      let formData = {
        s3urlKey: fileName
      }
      const resp = await http.post(`${constants.API_URL}/api/get-studentdocumenturl`, formData, { responseType: 'json' }
      )
      return resp
    }
  }
}
</script>
